define('modules/pages/customers/detail/body/catalog/headerTools/view',[
  'app',
  'module',
  'underscore',
  'jquery',
  'settings',
  'tableHeaderFieldView',
  'buttonView',
  'productSelectDialogView',
  'bootbox'
], function (
  App,
  Module,
  _,
  $,
  Settings,
  HeaderFieldView,
  ButtonView,
  ProductSelectDialog,
  bootbox
) {
  'use strict';

  function i18nOr(defKey, fallback) {
    try { return _.i18n(defKey) || fallback; } catch (e) { return fallback; }
  }

  // Resolve product code from selection item. Returns a jQuery Promise resolving to the code string.
  function resolveProductCode(item) {
    try {
      var productModel = App.request && App.request('products:model', { secId: item.rowid });
      if (productModel && productModel.fetch) {
        var d = $.Deferred();
        productModel.fetch().done(function () {
          d.resolve(productModel.get('cCode'));
        }).fail(function () {
          d.resolve(item.rowid);
        });
        return d.promise();
      }
    } catch (e) {}
    return $.Deferred().resolve(item.rowid).promise();
  }

  Module.exports = HeaderFieldView.extend({
    // Simple header with an Add button region
    template: function () {
      return '' +
        '<div class="customers-catalogs-header-tools-view">' +
          '<div class="add-region"></div>' +
        '</div>';
    },
    className: 'customers-catalogs-header-tools-view ' + HeaderFieldView.prototype.className,

    regions: {
      addRegion: '.add-region'
    },

    onRender: function () {
      this.addButtonView = new ButtonView({
        type: 'add',
        color: 'orange',
        text: i18nOr('catalogs.createNew', 'Create catalog'),
        title: i18nOr('catalogs.createNew', 'Create catalog')
      });
      this.getRegion('addRegion').show(this.addButtonView);
      this.addButtonView.on('click', _.bind(this.onAdd, this));
    },

    onAdd: function () {
      var that = this;
      // end user comes from table view model
      var endUserSecId = this.tableView && this.tableView.model && this.tableView.model.get && this.tableView.model.get('secId');
      if (!endUserSecId) {
        try { if (App.alertError) { App.alertError(i18nOr('common.error', 'Error')); } } catch (e) { bootbox.alert(i18nOr('common.error', 'Error')); }
        return;
      }

      // Build dialog content
      var html = [
        '<div class="catalog-create-dialog">',
        '  <div class="form-group">',
        '    <label>', i18nOr('catalogs.definition', 'Catalog definition'), '</label>',
        '    <select class="form-control js-definition"></select>',
        '  </div>',
        '  <div class="form-group">',
        '    <div class="clearfix" style="margin-bottom:6px;">',
        '      <label style="margin:0;">', i18nOr('menu.products', 'Products'), '</label>',
        '      <button type="button" class="btn btn-xs btn-default pull-right js-add-products">', i18nOr('catalogs.addProducts', 'Add products'), '</button>',
        '    </div>',
        '    <ul class="js-products sortable"></ul>',
        '    <div class="help-block">', i18nOr('common.dragToReorder', 'Drag to reorder'), '</div>',
        '  </div>',
        '</div>'
      ].join('');
      var $content = $(html);

      bootbox.dialog({
        title: i18nOr('catalogs.createNew', 'Create catalog'),
        message: $content,
        className: 'catalog-create-popup',
        buttons: {
          cancel: { label: i18nOr('common.cancel', 'Cancel'), className: 'btn-default' },
          save: {
            label: i18nOr('common.save', 'Save'), className: 'btn-primary', callback: function () {
              var defSecId = $content.find('.js-definition').val();
              var newProducts = [];
              $content.find('.js-products > li').each(function (idx, li) {
                var code = $(li).attr('data-code');
                if (code) newProducts.push({ productCode: code, displayOrder: idx });
              });
              var payload = {
                endUserSecId: endUserSecId,
                productCatalogDefinition: { secId: defSecId },
                products: newProducts
              };
              var url = Settings.url('compuzz2', 'v2/catalog/instances');
              return $.ajax({
                type: 'POST',
                url: url,
                contentType: 'application/json',
                data: JSON.stringify(payload)
              }).done(function () {
                try { if (App.alertSuccess) { App.alertSuccess(i18nOr('catalogs.created', 'Catalog created')); } } catch (e) {}
                // refresh table and count
                try { that.tableView.refresh(); } catch (e) {}
              }).fail(function (xhr) {
                var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || i18nOr('common.error', 'Error');
                try { if (App.alertError) { App.alertError(msg); } } catch (e) { bootbox.alert(msg); }
                return false;
              });
            }
          }
        }
      });

      // Populate definitions
      var defUrl = Settings.url('compuzz2', 'v2/catalog/definitions');
      $.get(defUrl).done(function (defs) {
        var $sel = $content.find('.js-definition');
        _.each(defs || [], function (d) {
          var name = (d.name && (d.name.values && (d.name.values[Settings.get('lang')] || d.name.values.en || d.name.values.fr))) ||
                     (d.name && (d.name[Settings.get('lang')] || d.name.en || d.name.fr)) ||
                     '';
        var $opt = $('<option></option>').attr('value', d.secId).text(name || d.secId);
        $sel.append($opt);
        });
      });

      // Products list behavior
      var $list = $content.find('.js-products');
      try { $list.sortable({ items: '> li', handle: '.drag-handle', axis: 'y', tolerance: 'pointer' }); } catch (e) {}

      $content.find('.js-add-products').on('click', function () {
        var dlg = new ProductSelectDialog({ multiSelect: true, displayLeaveButton: false });
        dlg.listenTo(dlg, 'products-selected', function (selected) {
          var existingCodes = [];
          $list.find('li').each(function () { var c = $(this).attr('data-code'); if (c) existingCodes.push(String(c)); });
          var promises = _.map(selected || [], function (it) { return resolveProductCode(it); });
          $.when.apply($, promises).always(function () {
            var results = arguments;
            var codes = [];
            for (var i = 0; i < results.length; i++) {
              var r = results[i];
              codes.push(_.isArray(r) ? r[0] : r);
            }
            _.each(codes, function (code) {
              code = code !== null ? String(code) : '';
              if (code && existingCodes.indexOf(code) === -1) {
                existingCodes.push(code);
                var $li = $('<li class="sortable-item" style="display:flex; align-items:center; padding:4px 0;"></li>').attr('data-code', code);
                var $handle = $('<span class="drag-handle" style="cursor:move; margin-right:6px;">⋮⋮</span>');
                var $label = $('<span class="item-label" style="flex:1; min-width:0;"></span>').text(code);
                var $removeRegion = $('<span class="remove-button-region" style="margin-left:6px;"></span>');
                try {
                  var removeBtn = new ButtonView({ type: 'remove', color: 'red', text: i18nOr('common.remove', 'Remove'), title: i18nOr('common.remove', 'Remove') });
                  removeBtn.render();
                  $removeRegion.append(removeBtn.$el);
                  removeBtn.on('click', function () { $li.remove(); });
                } catch (e) {
                  var $fallback = $('<span class="text-danger" style="cursor:pointer;">' + i18nOr('common.remove', 'Remove') + '</span>');
                  $fallback.on('click', function(){ $li.remove(); });
                  $removeRegion.append($fallback);
                }
                $li.append($handle).append($label).append($removeRegion);
                $list.append($li);
              }
            });
            try {
              if ($list.data('ui-sortable')) { $list.sortable('refresh'); }
              else { $list.sortable({ items: '> li', handle: '.drag-handle', axis: 'y', tolerance: 'pointer' }); }
            } catch (e) {}
            dlg.hide();
          });
        });
        dlg.show({ title: i18nOr('dialog.offer.selectProduct', 'Select products'), className: 'product-selection-dialog' });
      });
    }
  });
});

